import React, { useRef, useState, useEffect, forwardRef } from 'react';

import Form from 'rsuite/Form';
import FlexboxGrid from 'rsuite/FlexboxGrid';
import Grid from 'rsuite/Grid';
import Row from 'rsuite/Row';
import Col from 'rsuite/Col';
import { Input, IconButton } from 'rsuite';
import EmailIcon from '@rsuite/icons/Email';
import { Notification, useToaster } from 'rsuite';
import api from 'Components/_helpers/api';

/*------------- OTHERS ------------------------------------------------------*/
import { SchemaModel, StringType } from 'schema-typed';

const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

const model = SchemaModel({
  cc: StringType(),
  cco: StringType(),
  email: StringType()
    .isEmail('Por favor ingrese la dirección de correo electrónico correcta')
    .isRequired('Este campo no puede estar vacío'),
  message: StringType().isRequired('Campo requerido'),
});

const TextField = forwardRef((props, ref) => {
  const { name, label, accepter, ...rest } = props;

  return (
    <Form.Group controlId={`${name}-4`} ref={ref}>
      <Form.ControlLabel>{label} </Form.ControlLabel>
      <Form.Control name={name} accepter={accepter} {...rest} />
    </Form.Group>
  );
});

const TextArea = forwardRef((props, ref) => {
  const { name, label, accepter, ...rest } = props;

  return (
    <Form.Group controlId={`${name}-4`} ref={ref}>
      <Form.ControlLabel>{label} </Form.ControlLabel>
      <Form.Control name={name} rows={5} accepter={Textarea} {...rest} />
    </Form.Group>
  );
});

export default function SendMailForm(props) {
  const { codigoGeneracion, dteType } = props;
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const [, setFormError] = useState({});
  const toaster = useToaster();
  const [formValue, setFormValue] = useState({
    cc: '',
    cco: '',
    email: '',
    message: '',
  });

  const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleSubmit = async () => {
    let formStatus = await formRef.current.checkAsync();
    if (formStatus.hasError) {
      return;
    } else {
      let invalidEMails = [];

      if (formValue.cc) {
        invalidEMails = invalidEMails.concat(
          formValue.cc.split(';').filter((e) => {
            if (!validateEmail(e)) return e;
            else return false;
          })
        );
      }

      if (formValue.cco) {
        invalidEMails = invalidEMails.concat(
          formValue.cco.split(';').filter((e) => {
            if (!validateEmail(e)) return e;
            else return false;
          })
        );
      }

      if (invalidEMails.length > 0) {
        toaster.push(
          <Notification type={'error'} header={`DTE Manager`} closable>
            <p>{'No se pudo enviar el correo. Revisa las direcciones ingresadas:'}</p>
            <ul>
              {invalidEMails.map((e) => (
                <li>{e}</li>
              ))}
            </ul>
          </Notification>,
          { placement: 'topEnd' }
        );
        return;
      }

      setLoading(true);
      api
        .post(`${api.getUri()}${dteType}/Notify`, {
          CodigoGeneracion: codigoGeneracion,
          Message: formValue.message,
          Receptores: formValue.email,
          ReceptoresCC: formValue.cc.split(','),
          ReceptoresCCO: formValue.cco.split(','),
        })
        .then((res) => {
          toaster.push(
            <Notification type={'info'} header={`DTE Manager`} closable>
              <p>{'DTE enviado correctamente.'}</p>
            </Notification>,
            { placement: 'topEnd' }
          );
        })
        .catch((e) => {
          console.log('error', e);
          toaster.push(
            <Notification type={'error'} header={`DTE Manager`} closable>
              <p>{'No se pudo enviar el correo. No está disponible el servidor de correo.'}</p>
            </Notification>,
            { placement: 'topEnd' }
          );
        })
        .then(() => setLoading(false));
    }
  };

  const handleChangeForm = (value) => {
    setFormValue(value);
  };

  useEffect(() => {}, []);

  return (
    <Grid fluid>
      <Row>
        <Col xs={24}>
          <Form ref={formRef} onChange={handleChangeForm} onCheck={setFormError} formValue={formValue} model={model}>
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24}>
                  <TextField
                    checkAsync
                    name="email"
                    classPrefix="full_width"
                    placeholder="Correo electrónico"
                    label="Correo electrónico"
                    autoComplete="new-email"
                  />
                </Col>
              </Row>
            </Grid>
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24}>
                  <TextField checkAsync name="cc" classPrefix="full_width" placeholder="CC" label="CC" autoComplete="new-email" />
                </Col>
              </Row>
            </Grid>
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24}>
                  <TextField checkAsync name="cco" classPrefix="full_width" placeholder="CCO" label="CCO" autoComplete="new-email" />
                </Col>
              </Row>
            </Grid>
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24} md={24}>
                  <TextArea name="message" classPrefix="full_width" placeholder="Mensaje" label="Mensaje" />
                </Col>
              </Row>
            </Grid>

            <FlexboxGrid>
              <FlexboxGrid.Item colspan={24}>
                <IconButton loading={loading} onClick={handleSubmit} appearance="primary" icon={<EmailIcon />}>
                  Enviar
                </IconButton>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Form>
        </Col>
      </Row>
    </Grid>
  );
}
